import React, { useEffect, useState } from 'react';
import Calendly from "../components/Calendly"
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

const OpenModal = (props) => {

  // MODAL: Handle visibility
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
      <div>
        <button
          onClick={handleShow}
          id={"btn-header"}
          className={props.btn_class ||"btn btn-primary"} >
            {props.btn_anchor || 'Schedule a FREE consultation'}
          </button>
        <Modal show={show}
               onHide={handleClose}
               size="lg"
               aria-labelledby="contained-modal-title-vcenter"
               centered>
          <Modal.Header closeButton>
          </Modal.Header>
          <Modal.Body>
            <Calendly />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button variant="primary" onClick={handleClose}>
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
}

export default OpenModal;